/* ==========================================================================
   FUEL HOME VIDEO GATE.

   RJ item 16, 2026-09-02: "The video on the homepage must autoplay."
   templates/index.json now sets video_autoplay: true on section_RhpYRt's
   stock 'video' block, which is what actually produces the real
   autoplay + muted + playsinline + loop attributes on the <video> element -
   Shopify's own snippets/video.liquid (stock, not owned by this lane) wires
   video_tag: autoplay: true, muted: true, loop: video_loop, and adds
   playsinline itself; nothing here sets those attributes, and none of them
   is added by script, which is the one thing the brief explicitly warned
   against ("muted... must be a real attribute on the element, not set later
   by script").

   THE ONE THING THIS FILE DOES: the same brief also says not to autoplay a
   heavy file on a metered connection, gated behind prefers-reduced-motion
   and navigator.connection.saveData, poster as the fallback. Neither signal
   is readable at Liquid render time (both are client-only), so the gate has
   to run after paint. It downgrades rather than removes: the <video> is
   already server-rendered and already has a still first frame the instant
   it exists in the DOM (that frame IS the fallback poster here - no
   separate image element is inserted, so nothing can be a CLS source), so
   this only needs to stop playback and stop it restarting.

   Scoped to the homepage only by the {% if template == 'index' %} guard
   that loads this file from layout/theme.liquid, and additionally scoped
   here to video[autoplay] so a future second autoplaying video on the same
   page is covered without a second script.
   ========================================================================== */
(function () {
  'use strict';

  function shouldSkipAutoplay() {
    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = !!(navigator.connection && navigator.connection.saveData);
    return reduced || saveData;
  }

  function gate() {
    if (!shouldSkipAutoplay()) return;

    var videos = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      try {
        v.pause();
      } catch (e) {
        // A video element that never started (e.g. the browser blocked
        // autoplay on its own before this ran) throws on pause() in some
        // engines. Either way the outcome we want - not playing - already
        // holds, so this is a no-op failure, not an error to surface.
      }
      v.removeAttribute('autoplay');
      v.loop = false;
      v.currentTime = 0;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gate);
  } else {
    gate();
  }
})();
